import { Component, EventEmitter, OnInit, Output, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-guard-confirm',
  templateUrl: './guard-confirm.component.html',
  styleUrls: ['./guard-confirm.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GuardConfirmComponent {

  @Output() confirmed = new EventEmitter<boolean>();
  title: string;
  message: string;

  confirm() {
    this.confirmed.emit(true);
  }

  cancel() {
    this.confirmed.emit(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/guard/guard-confirm/guard-confirm.component.ts